import { MouseEventHandler } from 'react';

type Props = {
  icon: string | '';
  label?: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
  cy?: string | undefined;
  iconPlacement?: string;
};

export default function Icon({
  icon,
  label,
  className,
  onClick,
  cy,
  iconPlacement = 'left',
}: Props) {
  const _icon = (
    <i
      data-cy={cy}
      role={'button'}
      className={className + ' ' + icon}
      onClick={onClick}
    />
  );
  return typeof label !== 'undefined' && icon ? (
    <div
      role={'button'}
      className={'d-flex  align-items-center'}
    >
      {iconPlacement === 'left' && _icon}{' '}
      <span className={iconPlacement === 'left' ? 'ps-3' : 'pe-3'}>{label}</span>
      {iconPlacement === 'right' && _icon}
    </div>
  ) : (
    _icon
  );
}
